import React, { FunctionComponent, ReactElement } from 'react';
import { Tooltip as MuiTooltip, TooltipProps, Avatar } from '@mui/material';
import cx from 'classnames';
import { LightbulbIcon } from '../../assets/icons';
import useStyles from './Tooltip.styles';

interface IProps extends Omit<TooltipProps, 'children'> {
  id: string;
  customClass?: string;
  variant?: string;
  children?: ReactElement;
}

const Tooltip: FunctionComponent<IProps> = ({
  customClass = '',
  variant = '',
  id,
  children,
  ...props
}) => {
  const styles = useStyles();

  return (
    <MuiTooltip
      id={id}
      data-testid={id}
      classes={{
        tooltip: cx(styles.tooltip, {
          [customClass]: customClass,
        }),
      }}
      {...props}
    >
      {children ? (
        children
      ) : (
        <Avatar className={styles.avatar}>
          <LightbulbIcon />
        </Avatar>
      )}
    </MuiTooltip>
  );
};

export default Tooltip;